import { type ReactNode } from "react";
import { Inbox } from "lucide-react";
import { cn } from "../../lib/utils";

interface EmptyStateProps {
  title: string;
  hint?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({
  title,
  hint,
  icon,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "neu-canvas rounded-2xl p-8 flex flex-col items-center text-center gap-3",
        className,
      )}
      role="status"
    >
      <div className="neu-inset rounded-full p-3 text-muted-foreground">
        {icon ?? <Inbox className="h-5 w-5" aria-hidden="true" />}
      </div>
      <div className="space-y-1">
        <p className="text-sm font-medium text-foreground">{title}</p>
        {hint && <p className="text-sm text-muted-foreground">{hint}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}

interface EmptyTableRowProps {
  colSpan: number;
  children: ReactNode;
}

export function EmptyTableRow({ colSpan, children }: EmptyTableRowProps) {
  return (
    <tr>
      <td colSpan={colSpan} className="px-4 py-8 text-center">
        <span className="inline-flex items-center gap-2 font-mono text-sm text-muted-foreground">
          <Inbox className="h-3.5 w-3.5" aria-hidden="true" />
          {children}
        </span>
      </td>
    </tr>
  );
}
